// @flow
import * as React from 'react';
import styles from './Placeholder.css';

type Props = {
  editable: boolean,
  onClickAddOrderGroup: () => void
}

class Component extends React.PureComponent<Props> {

  render () {

    const {
      editable,
      onClickAddOrderGroup
    } = this.props;

    return (

      <div
        className={styles.wrapper}
      >

        <div className={styles.message}>

          {'This order is empty. '}

          {editable && (
            <span>
              <span
                className={styles.addLink}
                onClick={() => onClickAddOrderGroup()}
                role="presentation"
              >
                {'Add a group'}
              </span>
              {' to get started.'}
            </span>
          )}

        </div>

      </div>

    )
  }
}

export default Component;